interface SectionHeadProps {
  eyebrow: string;
  title: string;
  sub?: string;
  align?: 'left' | 'center';
}

export default function SectionHead({ eyebrow, title, sub, align = 'center' }: SectionHeadProps) {
  return (
    <div className={`mb-8 flex flex-col gap-3 md:mb-10 ${align === 'center' ? 'items-center text-center' : 'items-start text-left'}`}>
      <span className="section-eyebrow">
        <i className="ri-fire-fill text-xs" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
      {sub ? <p className="max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{sub}</p> : null}
    </div>
  );
}